import axios from 'axios';

/**
 * 해외(영문 홈페이지) 견적 문의 — 첨부 1개(5MB)를 함께 multipart 로 보낸다.
 * 서버: POST /estimate/overseas (OverseasEstimateRestController). 입력 오류면 400 { message } (영어).
 */
export async function createOverseasEstimate(fields, file) {
  const body = new FormData();
  Object.entries(fields).forEach(([k, v]) => body.append(k, v == null ? '' : String(v)));
  if (file) body.append('file', file);
  const { data } = await axios.post('/estimate/overseas', body, { timeout: 120000 });
  return data;
}
